import { forwardRef } from 'react';
import classnames from 'classnames';
import Slider from 'react-slick';

import { makeStyles } from '@mui/styles';

import TestimonyItem from './TestimonyItem';

export const SLICK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel';
export const SLICK_VERSION = '1.6.0';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ palette, spacing, typography }) => ({
    '@import': [
      `url(${SLICK_URL}/${SLICK_VERSION}/slick.min.css)`,
      `url(${SLICK_URL}/${SLICK_VERSION}/slick-theme.min.css)`,
    ],
    dots: {
      bottom: -25,
      width: '100%',
      margin: [[spacing(1), 0, spacing(3), 0]],
      padding: 0,
      listStyle: 'none',
      textAlign: 'center',

      '& li': {
        position: 'relative',
        display: 'inline-block',
        width: 20,
        height: 20,
        margin: '0 5px',
        padding: 0,
        cursor: 'pointer',

        '& button': {
          fontSize: 0,
          lineHeight: 0,
          display: 'block',
          width: 20,
          height: 20,
          padding: 5,
          cursor: 'pointer',
          color: 'transparent',
          border: 0,
          outline: 0,
          background: '0 0',

          '&:before': {
            fontSize: typography.pxToRem(30),
            lineHeight: typography.pxToRem(20),
            position: 'absolute',
            top: 0,
            left: 0,
            width: 20,
            height: 20,
            content: '"•"',
            textAlign: 'center',
            opacity: 0.25,
            color: palette.primary.main,
          },
        },

        '&.slick-active button:before': {
          opacity: 1,
        },
      },
    },
    withDashes: {
      margin: [[spacing(-1) * 3, 0, spacing(3), 0]],
      '& li': {
        '& button': {
          '&:before': {
            content: '"_"',
          },
        },
      },
    },
  }),
  { classNamePrefix: 'Carousel' }
);

const Carousel = forwardRef(
  (
    {
      children = null,
      classes: customClasses = {},
      className = '',
      shouldRenderDashes = false,
      slickSettings: settings = {
        infinite: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: false,
        swipe: true,
        variableWidth: false,
        fade: false,
        /* istanbul ignore next */
        beforeChange() {},
      },
      ...otherProps
    },
    ref
  ) => {
    const classes = useStyles({ classes: customClasses });

    const slickSettings = {
      ...settings,
      dotsClass: classnames(classes.dots, {
        [classes.withDashes]: shouldRenderDashes,
      }),
    };

    return (
      <Slider className={className} {...slickSettings} {...otherProps} ref={ref}>
        {children}
      </Slider>
    );
  }
);

Carousel.TestimonyItem = TestimonyItem;

export default Carousel;
